import React, { useEffect } from 'react'
import Footer from '../../componets/General/Footer'
import NavBar from '../../componets/General/NavBar'
import '../../style/RelojDigital.css'
class RelojDigital extends React.Component{
    state = {
        interval: null
    }
    componentDidMount(){
        
        window.scrollTo(0,0);

        function UpdateDate() { 
            var date= new Date(),
            hours=date.getHours(),
            ampm,
            minuts=date.getMinutes(),
            seconds=date.getSeconds(),
            weekDay=date.getDay(),
            day=date.getDate(),
            month=date.getMonth(),
           
            year=date.getFullYear();
   
            var pHour=document.getElementById('hour'),
            pAmpm=document.getElementById('ampm'),
            pMinut=document.getElementById('minut'),
            pSeconds=document.getElementById('seconds'),
            pWeekDay=document.getElementById('dayWeek'),
            pDay=document.getElementById('day'),
            pMonth=document.getElementById('month'),
            pYear=document.getElementById('year');
   
            var weekArray=['SUNDAY','MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY','SATURDAY'];
            var months =['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVENBER','DECEMBER'];
            pWeekDay.textContent=weekArray[weekDay];
            pDay.textContent=day ;
            pHour.textContent=hours;
            pMonth.textContent=months[month];
            pYear.textContent=year;
   
            if(hours==0){
            hours=12;
            ampm='AM';
            }
           else if(hours>=12){
           hours=hours-12;
           ampm='PM'
           }
           else ampm='AM';
           pHour.textContent=hours;
           pAmpm.textContent=ampm;
           if(minuts<10)
               minuts="0"+minuts;
           if(seconds<10)
               seconds="0"+minuts;
           pMinut.textContent=minuts;
           pSeconds.textContent=seconds;
       };
       this.setState({interval:setInterval(UpdateDate,1000)});
    }
    componentWillUnmount(){
        clearInterval(this.state.interval);
    }
    render(){
    return(
        <>
            <NavBar/>
            <div className="wrap p-5 text-white">
                <div className="container widget">
                    <div className="date">
                        <p id="dayWeek" className="dayWeek"> </p>
                        <span> </span>
                        <p id="day" className="day"> </p>
                        <span> </span>
                        <p id="month" className="month"> </p>
                        <span> </span>
                        <p id="year" className="year"> </p>

                    </div>
                    <div className="clock">
                        <p id="hour" className="hour"></p>
                        <p>:</p>
                        <p id="minut" className="minut"></p>
                        <p>:</p>
                        <div className="box">
                            <p id="ampm" className="ampm"></p>
                            <p id="seconds" className="seconds"></p>
                        </div>
                    </div>
                    
                </div>
            </div>
            <Footer/>
        </>
    )
}
}
export default RelojDigital